export const useStyles = () => ({
  linkText: {
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 12,
    },
  },
});
